import env from '../env.js'
import { getUserData } from '@/helpers/utils'

const state = {
    isLoading: false,
    AppActiveUser: getUserData(),
    domain: env.domain,
    localUserKey: env.localUserKey,
    appName: env.appName,
    config:{
        shortDesc: "Designed & Managed by The Ministry of Science & Digital Economy.",
        appEmail: "support@cbt.akwaibomstate.gov.ng"
    },
    appConfigData:{
        statusColors: []
    },
    scrollY: 0,
    windowWidth: window.innerWidth,
    dashboardData:{
        "unread_notifications": 0,
        "user": {},
        "candidate": {},
        "examinations": {},
    },
    lightbox:{
        index: null,
        visible: false,
        files: []
    },
    pdfModalFrame:{
        visible: false,
        filePath: ""
    },
}

export default state
